import React, { useEffect, useState, useRef } from 'react';
import CryptoJS from 'crypto-js';
import './AdminDash.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const AdminDash = () => {
  const [enlaceCreado, setEnlaceCreado] = useState('');
  const [solicitudesManuales, setSolicitudesManuales] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [manualData, setManualData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ciudad: '',
    departamento: '',
    nombre_empresa: '',
    planId: '',
  });
  const [planes, setPlanes] = useState([]);
  const modalRef = useRef();
  const [solicitudes, setSolicitudes] = useState([]);
  const [nuevoPlan, setNuevoPlan] = useState({
    name: '',
    price: '',
    features: '',
    description: '',
  });

  const [usuarios, setUsuarios] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [nuevaCategoria, setNuevaCategoria] = useState('');
  const [nuevaSubcategoria, setNuevaSubcategoria] = useState({ nombre: '', categoriaId: '' });
  const [editandoPlan, setEditandoPlan] = useState(null);

  const eliminarPlan = async (id) => {
    const token = localStorage.getItem('token');
    const confirmar = window.confirm || (() => true);
    if (!confirmar('¿Estás seguro de eliminar este plan?')) return;

    try {
      const res = await fetch(`https://api.minymol.com/plans/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error('No se pudo eliminar el plan');

      setPlanes((prev) => prev.filter((p) => p.id !== id));
      alert('✅ Plan eliminado');
    } catch (err) {
      alert('❌ Error al eliminar el plan');
    }
  };

  const guardarEdicionPlan = async (id) => {
    const token = localStorage.getItem('token');
    const { name, description, price, features } = editandoPlan;

    if (!name.trim() || isNaN(price)) {
      alert('❌ Nombre y precio son obligatorios');
      return;
    }

    try {
      const res = await fetch(`https://api.minymol.com/plans/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: name.trim(),
          description: description?.trim(),
          price: parseFloat(price),
          features: features
            .split('\n')
            .map((f) => f.trim())
            .filter(Boolean),
        }),
      });

      if (!res.ok) throw new Error();

      const data = await res.json();

      setPlanes((prev) => prev.map((p) => (p.id === id ? data : p)));
      setEditandoPlan(null);
      alert('✅ Plan actualizado');
    } catch (err) {
      alert('❌ Error al actualizar el plan');
    }
  };


  useEffect(() => {
    const fetchCategorias = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/categories', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setCategorias(data);
    };
    fetchCategorias();
  }, []);

  const crearCategoria = async () => {
    const token = localStorage.getItem('token');
    if (!nuevaCategoria.trim()) return alert('Nombre obligatorio');

    try {
      const res = await fetch('https://api.minymol.com/categories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: nuevaCategoria }),
      });
      if (!res.ok) throw new Error();
      alert('✅ Categoría creada');
      setNuevaCategoria('');
      const data = await res.json();
      setCategorias((prev) => [...prev, data]);
    } catch (err) {
      alert('❌ Error al crear categoría');
    }
  };

  const crearSubcategoria = async () => {
    const token = localStorage.getItem('token');
    const { nombre, categoriaId } = nuevaSubcategoria;

    if (!nombre.trim() || !categoriaId) return alert('Todos los campos son obligatorios');

    try {
      const res = await fetch('https://api.minymol.com/sub-categories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: nombre, categoryId: categoriaId }),
      });
      if (!res.ok) throw new Error();
      alert('✅ Subcategoría creada');
      setNuevaSubcategoria({ nombre: '', categoriaId: '' });
    } catch (err) {
      alert('❌ Error al crear subcategoría');
    }
  };


  useEffect(() => {
    const fetchUsuarios = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/users', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setUsuarios(data);
    };
    fetchUsuarios();
  }, []);


  useEffect(() => {
    const fetchSolicitudesManuales = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/manual-provider-requests', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSolicitudesManuales(data);
    };

    fetchSolicitudesManuales();
  }, []);


  useEffect(() => {
    const fetchSolicitudes = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/provider-requests', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSolicitudes(data);
    };

    fetchSolicitudes();
  }, []);

  const actualizarCampo = (id, campo, valor) => {
    const updated = solicitudes.map((s) =>
      s.id === id ? { ...s, [campo]: valor } : s
    );
    setSolicitudes(updated);
  };

  const revisarSolicitud = async (s) => {
    const token = localStorage.getItem('token');
    const estadoValido = (s.estado || '').toLowerCase();

    const body = {
      numeroRUT: s.numeroRUT,
      numeroCamaraComercio: s.numeroCamaraComercio,
      estado: estadoValido,
    };

    await fetch(`https://api.minymol.com/provider-requests/${s.id}/revisar`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    alert('Solicitud revisada');
    window.location.reload();
  };

  const convertirEnProveedor = async (id) => {
    const token = localStorage.getItem('token');
    await fetch(`https://api.minymol.com/provider-requests/${id}/convertir`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
    });
    alert('Proveedor creado con éxito');
    window.location.reload();
  };

  const handleChangePlan = (campo, valor) => {
    setNuevoPlan((prev) => ({ ...prev, [campo]: valor }));
  };

  const crearPlan = async () => {
    const token = localStorage.getItem('token');

    const body = {
      name: nuevoPlan.name.trim(),
      description: nuevoPlan.description?.trim(),
      price: parseFloat(nuevoPlan.price),
      features: nuevoPlan.features
        .split('\n')
        .map((f) => f.trim())
        .filter(Boolean),
    };

    try {
      const res = await fetch('https://api.minymol.com/plans', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error('Error al crear el plan');

      alert('✅ Plan creado con éxito');
      setNuevoPlan({ name: '', price: '', features: '', description: '' });
    } catch (err) {
      console.error(err);
      alert('❌ No se pudo crear el plan');
    }
  };

  useEffect(() => {
    const fetchCategorias = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/categories/with/sub-categories', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setCategorias(data);
    };
    fetchCategorias();
  }, []);


  useEffect(() => {
    const fetchPlanes = async () => {
      const token = localStorage.getItem('token');
      const res = await fetch('https://api.minymol.com/plans', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setPlanes(data);
    };
    fetchPlanes();
  }, []);

  const handleManualChange = (campo, valor) => {
    setManualData((prev) => ({ ...prev, [campo]: valor }));
  };

  const editarCategoria = async (id, nuevoNombre) => {
    const token = localStorage.getItem('token');
    if (!nuevoNombre.trim()) return alert('❌ El nombre es obligatorio');
    try {
      await fetch(`https://api.minymol.com/categories/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: nuevoNombre }),
      });
      alert('✅ Categoría actualizada');
    } catch (err) {
      alert('❌ Error al editar categoría');
    }
  };

  const editarSubcategoria = async (id, nuevoNombre) => {
    const token = localStorage.getItem('token');
    if (!nuevoNombre.trim()) return alert('❌ El nombre es obligatorio');
    try {
      await fetch(`https://api.minymol.com/sub-categories/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: nuevoNombre }),
      });
      alert('✅ Subcategoría actualizada');
    } catch (err) {
      alert('❌ Error al editar subcategoría');
    }
  };

  const eliminarSubcategoria = async (id) => {
    const token = localStorage.getItem('token');
    const confirmar = window?.confirm || (() => true); // fallback en caso raro
    if (!confirmar('¿Estás seguro de eliminar esta subcategoría?')) return;

    try {
      await fetch(`https://api.minymol.com/sub-categories/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      setCategorias((prev) =>
        prev.map((c) => ({
          ...c,
          subcategories: c.subcategories?.filter((s) => s.id !== id),
        }))
      );
      alert('✅ Subcategoría eliminada');
    } catch (err) {
      alert('❌ Error al eliminar subcategoría');
    }
  };


  const convertirUsuarioEnProveedor = async (userId) => {
    const token = localStorage.getItem('token');
    const user = usuarios.find((u) => u.id === userId);
    const campos = user;

    if (!campos.nombre_empresa || !campos.rut || !campos.camara_comercio || !campos.descripcion || !campos.planId) {
      alert('❌ Completa todos los campos requeridos para convertir este usuario');
      return;
    }

    try {
      // Paso 1: Crear proveedor
      const resProveedor = await fetch('https://api.minymol.com/providers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          usuario_id: userId,
          nombre_empresa: campos.nombre_empresa,
          rut: campos.rut,
          camara_comercio: campos.camara_comercio,
          descripcion: campos.descripcion,
        }),
      });

      if (!resProveedor.ok) throw new Error('Error creando el proveedor');
      const proveedorCreado = await resProveedor.json();

      // Paso 2: Cambiar rol del usuario
      const resUser = await fetch(`https://api.minymol.com/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ rol: 'proveedor' }),
      });

      if (!resUser.ok) throw new Error('Error actualizando el rol del usuario');

      // 🔥 Paso 3: Crear el pago manualmente como aprobado
      const resPago = await fetch('https://api.minymol.com/payments/create-manual', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          providerId: proveedorCreado.id,
          planId: campos.planId,
          amount: parseFloat(campos.price || '0'), // ⚠️ asegúrate de tener el precio
          status: 'approved',
          externalReference: `manual-${Date.now()}`,
        }),
      });


      if (!resPago.ok) throw new Error('Error creando el pago');
      const pagoCreado = await resPago.json();

      // Paso 4: Crear suscripción (con pago asociado)
      const startDate = new Date().toISOString();
      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + 1);

      const resSub = await fetch('https://api.minymol.com/subscriptions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          providerId: proveedorCreado.id,
          planId: campos.planId,
          paymentId: pagoCreado.id, // Asociar pago
          startDate,
          endDate: endDate.toISOString(),
        }),
      });

      if (!resSub.ok) throw new Error('Error creando la suscripción');

      // Paso 5: Marcar como verificado
      const resVerificado = await fetch(`https://api.minymol.com/providers/${proveedorCreado.id}/estado`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ estado: 'verificado' }),
      });

      if (!resVerificado.ok) throw new Error('Error marcando como verificado');

      alert('✅ Usuario convertido en proveedor correctamente');
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert('❌ Hubo un error al convertir al usuario');
    }
  };



  const crearEnlaceManual = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('https://api.minymol.com/manual-provider-requests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(manualData),
      });

      const data = await res.json();
      if (!res.ok) throw new Error('Error creando solicitud');

      const encryptedToken = CryptoJS.AES.encrypt(
        JSON.stringify({ id: data.token, planId: manualData.planId }),
        'clave-secreta'
      ).toString();

      const enlace = `https://minymol.com/plans/${encodeURIComponent(encryptedToken)}`;
      setEnlaceCreado(enlace);

      setModalVisible(false);
    } catch (err) {
      console.error(err);
      alert('No se pudo crear el enlace');
    }
  };

  const actualizarCampoUsuario = (id, campo, valor) => {
    const updated = usuarios.map((u) =>
      u.id === id ? { ...u, [campo]: valor } : u
    );
    setUsuarios(updated);
  };


  return (
    <>
      <Header minimal={true} />
      <div className="admin-dash-container">
        {/* BOTONES DE ACCIONES PRINCIPALES */}
        <div className="admin-actions">
          <button
            className="btn-partners-admin"
            onClick={() => window.location.href = '/admin/partners'}
          >
            👥 Administrar Partners
          </button>
          <button className="btn-manual-link" onClick={() => setModalVisible(true)}>
            💳 Crear enlace de pago manual
          </button>
        </div>

        <h2>Todos los usuarios</h2>
        <div className='tabla-de-usarios'>
          <table className="tabla-usuarios">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Email</th>
                <th>Teléfono</th>
                <th>Rol</th>
                <th>Empresa</th>
                <th>RUT</th>
                <th>Cámara</th>
                <th>Descripción</th>
                <th>Plan</th>
                <th>Acción</th>
                <th>¿Puede editar visibilidad?</th>
                <th>Mostrar Público</th>
                <th>Mostrar Privado</th>
                <th>Catálogo Privado</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u) => {
                const esProveedor = u.rol === 'proveedor';
                const proveedor = u.proveedorInfo || {};

                return (
                  <tr key={u.id}>
                    <td>{u.nombre}</td>
                    <td>{u.email}</td>
                    <td>{u.telefono}</td>
                    <td>{u.rol}</td>

                    {esProveedor ? (
                      <>
                        <td>{proveedor.nombre_empresa}</td>
                        <td>{proveedor.rut}</td>
                        <td>{proveedor.camara_comercio}</td>
                        <td>{proveedor.descripcion}</td>
                        <td>—</td>
                        <td>Ya es proveedor</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={proveedor.canChangeVisibility}
                            onChange={async (e) => {
                              const nuevoValor = e.target.checked;
                              const token = localStorage.getItem('token');

                              try {
                                const res = await fetch(`https://api.minymol.com/providers/${proveedor.id}/permiso-visibilidad`, {
                                  method: 'PUT',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ canChangeVisibility: nuevoValor }),
                                });

                                if (!res.ok) throw new Error('Error al cambiar permiso');
                                alert('✅ Permiso actualizado');

                                // Actualizar localmente el estado
                                setUsuarios(prev =>
                                  prev.map(u =>
                                    u.proveedorInfo?.id === proveedor.id
                                      ? {
                                        ...u,
                                        proveedorInfo: {
                                          ...u.proveedorInfo,
                                          canChangeVisibility: nuevoValor,
                                        },
                                      }
                                      : u
                                  )
                                );
                              } catch (err) {
                                alert('❌ Error al actualizar el permiso');
                              }
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={proveedor.mostrarPublico}
                            onChange={async (e) => {
                              const nuevoValor = e.target.checked;
                              const token = localStorage.getItem('token');

                              try {
                                const res = await fetch(`https://api.minymol.com/providers/${proveedor.id}/catalog-visibility`, {
                                  method: 'PUT',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ mostrarPublico: nuevoValor }),
                                });

                                if (!res.ok) throw new Error('Error al cambiar visibilidad pública');
                                alert('✅ Visibilidad pública actualizada');

                                // Actualizar localmente el estado
                                setUsuarios(prev =>
                                  prev.map(u =>
                                    u.proveedorInfo?.id === proveedor.id
                                      ? {
                                        ...u,
                                        proveedorInfo: {
                                          ...u.proveedorInfo,
                                          mostrarPublico: nuevoValor,
                                        },
                                      }
                                      : u
                                  )
                                );
                              } catch (err) {
                                alert('❌ Error al actualizar la visibilidad pública');
                              }
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={proveedor.mostrarPrivado}
                            onChange={async (e) => {
                              const nuevoValor = e.target.checked;
                              const token = localStorage.getItem('token');

                              try {
                                const res = await fetch(`https://api.minymol.com/providers/${proveedor.id}/catalog-visibility`, {
                                  method: 'PUT',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ mostrarPrivado: nuevoValor }),
                                });

                                if (!res.ok) throw new Error('Error al cambiar visibilidad privada');
                                alert('✅ Visibilidad privada actualizada');

                                // Actualizar localmente el estado
                                setUsuarios(prev =>
                                  prev.map(u =>
                                    u.proveedorInfo?.id === proveedor.id
                                      ? {
                                        ...u,
                                        proveedorInfo: {
                                          ...u.proveedorInfo,
                                          mostrarPrivado: nuevoValor,
                                        },
                                      }
                                      : u
                                  )
                                );
                              } catch (err) {
                                alert('❌ Error al actualizar la visibilidad privada');
                              }
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            checked={proveedor.hasPrivateCatalog}
                            onChange={async (e) => {
                              const nuevoValor = e.target.checked;
                              const token = localStorage.getItem('token');

                              try {
                                const res = await fetch(`https://api.minymol.com/providers/${proveedor.id}/private-catalog`, {
                                  method: 'PUT',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ hasPrivateCatalog: nuevoValor }),
                                });

                                if (!res.ok) throw new Error('Error al cambiar estado de catálogo privado');
                                alert('✅ Estado de catálogo privado actualizado');

                                // Actualizar localmente el estado
                                setUsuarios(prev =>
                                  prev.map(u =>
                                    u.proveedorInfo?.id === proveedor.id
                                      ? {
                                        ...u,
                                        proveedorInfo: {
                                          ...u.proveedorInfo,
                                          hasPrivateCatalog: nuevoValor,
                                        },
                                      }
                                      : u
                                  )
                                );
                              } catch (err) {
                                alert('❌ Error al actualizar el estado de catálogo privado');
                              }
                            }}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <td><input onChange={(e) => actualizarCampoUsuario(u.id, 'nombre_empresa', e.target.value)} /></td>
                        <td><input onChange={(e) => actualizarCampoUsuario(u.id, 'rut', e.target.value)} /></td>
                        <td><input onChange={(e) => actualizarCampoUsuario(u.id, 'camara_comercio', e.target.value)} /></td>
                        <td><input onChange={(e) => actualizarCampoUsuario(u.id, 'descripcion', e.target.value)} /></td>
                        <td>
                          <select onChange={(e) => actualizarCampoUsuario(u.id, 'planId', e.target.value)}>
                            <option value="">Selecciona un plan</option>
                            {planes.map((plan) => (
                              <option key={plan.id} value={plan.id}>{plan.name} - ${plan.price}</option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <button onClick={() => convertirUsuarioEnProveedor(u.id)}>Convertir en proveedor</button>
                        </td>
                        <td>—</td>
                        <td>—</td>
                        <td>—</td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>



        {enlaceCreado && (
          <div className="enlace-creado-box">
            <p><strong>Enlace generado:</strong></p>
            <input
              type="text"
              value={enlaceCreado}
              readOnly
              style={{ width: '100%', padding: '6px', marginBottom: '8px' }}
            />
            <button
              onClick={() => {
                navigator.clipboard.writeText(enlaceCreado);
                alert('📋 Enlace copiado al portapapeles');
              }}
            >
              Copiar enlace
            </button>
          </div>
        )}

        {modalVisible && (
          <div className="modal" ref={modalRef}>
            <div className="modal-content">
              <h3>Datos del proveedor</h3>
              <input type="text" placeholder="Nombre" onChange={(e) => handleManualChange('nombre', e.target.value)} />
              <input type="text" placeholder="Apellido" onChange={(e) => handleManualChange('apellido', e.target.value)} />
              <input type="text" placeholder="Teléfono" onChange={(e) => handleManualChange('telefono', e.target.value)} />
              <input type="email" placeholder="Correo (opcional)" onChange={(e) => handleManualChange('email', e.target.value)} />
              <input type="text" placeholder="Ciudad" onChange={(e) => handleManualChange('ciudad', e.target.value)} />
              <input type="text" placeholder="Departamento" onChange={(e) => handleManualChange('departamento', e.target.value)} />
              <input type="text" placeholder="Nombre del negocio" onChange={(e) => handleManualChange('nombre_empresa', e.target.value)} />
              <select onChange={(e) => handleManualChange('planId', e.target.value)}>
                <option value="">Selecciona un plan</option>
                {planes.map((plan) => (
                  <option key={plan.id} value={plan.id}>{plan.name} - ${plan.price}</option>
                ))}
              </select>
              <button className="btn-enlace" onClick={crearEnlaceManual}>Crear Enlace</button>
              <button className="btn-cerrar" onClick={() => setModalVisible(false)}>Cancelar</button>
            </div>
          </div>
        )}

        <h2>Solicitudes Manuales de Pago</h2>
        {solicitudesManuales.length === 0 ? (
          <p>No hay registros manuales.</p>
        ) : (
          solicitudesManuales.map((s) => (
            <div key={s.id} className="solicitud-card">
              <p><strong>Nombre:</strong> {s.nombre} {s.apellido}</p>
              <p><strong>Teléfono:</strong> {s.telefono}</p>
              <p><strong>Ciudad:</strong> {s.ciudad} ({s.departamento})</p>
              <p><strong>Negocio:</strong> {s.nombre_empresa}</p>
              <p><strong>Estado de Pago:</strong> {s.completed ? '✅ Pagado' : '❌ Pendiente'}</p>
              <p><strong>Fecha:</strong> {new Date(s.createdAt).toLocaleString()}</p>
            </div>
          ))
        )}

        <div className="crear-plan">
          <h2>Crear Nuevo Plan</h2>
          <input
            type="text"
            placeholder="Nombre del plan"
            value={nuevoPlan.name}
            onChange={(e) => handleChangePlan('name', e.target.value)}
          />
          <input
            type="number"
            placeholder="Precio (ej. 19.99)"
            value={nuevoPlan.price}
            onChange={(e) => handleChangePlan('price', e.target.value)}
          />
          <textarea
            placeholder="Descripción (opcional)"
            value={nuevoPlan.description}
            onChange={(e) => handleChangePlan('description', e.target.value)}
          />
          <textarea
            placeholder="Características (una por línea)"
            value={nuevoPlan.features}
            onChange={(e) => handleChangePlan('features', e.target.value)}
            rows={5}
          />
          <button className="btn-crear-plan" onClick={crearPlan}>
            Crear Plan
          </button>
        </div>

        <div className="lista-planes">
          <h2>Planes Actuales</h2>
          {planes.map((plan) => (
            <div key={plan.id} className="plan-box">
              {editandoPlan?.id === plan.id ? (
                <>
                  <input
                    value={editandoPlan.name}
                    onChange={(e) => setEditandoPlan({ ...editandoPlan, name: e.target.value })}
                    placeholder="Nombre"
                  />
                  <input
                    value={editandoPlan.price}
                    onChange={(e) => setEditandoPlan({ ...editandoPlan, price: e.target.value })}
                    type="number"
                    placeholder="Precio"
                  />
                  <textarea
                    value={editandoPlan.description}
                    onChange={(e) => setEditandoPlan({ ...editandoPlan, description: e.target.value })}
                    placeholder="Descripción"
                  />
                  <textarea
                    value={editandoPlan.features}
                    onChange={(e) => setEditandoPlan({ ...editandoPlan, features: e.target.value })}
                    placeholder="Características (una por línea)"
                    rows={4}
                  />
                  <button onClick={() => guardarEdicionPlan(plan.id)}>Guardar</button>
                  <button onClick={() => setEditandoPlan(null)}>Cancelar</button>
                </>
              ) : (
                <>
                  <p><strong>{plan.name}</strong> - ${plan.price}</p>
                  <p>{plan.description}</p>
                  <ul>
                    {plan.features?.map((f, i) => <li key={i}>✔️ {f}</li>)}
                  </ul>
                  <button onClick={() => setEditandoPlan({ ...plan, features: plan.features.join('\n') })}>
                    ✏️ Editar
                  </button>
                  <button onClick={() => eliminarPlan(plan.id)}>🗑️ Eliminar</button>
                </>
              )}
            </div>
          ))}
        </div>


        {/* SOLICITUDES */}
        <h2>Solicitudes de Proveedor</h2>
        {solicitudes.length === 0 ? (
          <p>No hay solicitudes registradas.</p>
        ) : (
          solicitudes.map((s) => (
            <div key={s.id} className="solicitud-card">
              <p><strong>Usuario:</strong> {s.usuario?.nombre}</p>
              <p><strong>Empresa:</strong> {s.nombre_empresa}</p>

              {(s.archivoRUT || s.archivoCamaraComercio) && (
                <div className="docs-preview">
                  <p><strong>Documentos subidos:</strong></p>
                  {s.archivoRUT && (
                    <a href={s.archivoRUT} target="_blank" rel="noopener noreferrer">
                      Ver RUT
                    </a>
                  )}
                  <br />
                  {s.archivoCamaraComercio && (
                    <a href={s.archivoCamaraComercio} target="_blank" rel="noopener noreferrer">
                      Ver Cámara de Comercio
                    </a>
                  )}
                </div>
              )}

              <label>Número RUT</label>
              <input
                type="text"
                value={s.numeroRUT || ''}
                onChange={(e) => actualizarCampo(s.id, 'numeroRUT', e.target.value)}
              />

              <label>Número Cámara de Comercio</label>
              <input
                type="text"
                value={s.numeroCamaraComercio || ''}
                onChange={(e) => actualizarCampo(s.id, 'numeroCamaraComercio', e.target.value)}
              />

              <label>Estado</label>
              <select
                value={s.estado}
                onChange={(e) => actualizarCampo(s.id, 'estado', e.target.value)}
              >
                <option value="pendiente">Pendiente</option>
                <option value="aprobado">Aprobado</option>
                <option value="rechazado">Rechazado</option>
              </select>

              <p><strong>Pago:</strong> {s.pagoRealizado ? '✅' : '❌'}</p>

              <button className="btn-revisar" onClick={() => revisarSolicitud(s)}>
                Guardar revisión
              </button>

              {s.estado === 'aprobado' && s.pagoRealizado && (
                <button className="btn-convertir" onClick={() => convertirEnProveedor(s.id)}>
                  Convertir en proveedor
                </button>
              )}
            </div>
          ))
        )}

        <div className="crear-categoria-subcategoria">
          <h2>Gestión de Categorías</h2>

          {/* Crear nueva categoría */}
          <input
            type="text"
            placeholder="Nueva categoría"
            value={nuevaCategoria}
            onChange={(e) => setNuevaCategoria(e.target.value)}
          />
          <button onClick={crearCategoria}>Crear Categoría</button>

          {/* Lista de categorías */}
          <ul>
            {categorias.map((cat) => (
              <li key={cat.id} style={{ marginTop: '16px' }}>
                <input
                  type="text"
                  value={cat.name}
                  onChange={(e) =>
                    setCategorias((prev) =>
                      prev.map((c) => (c.id === cat.id ? { ...c, name: e.target.value } : c))
                    )
                  }
                />
                <button onClick={() => editarCategoria(cat.id, cat.name)}>💾 Guardar</button>

                {/* Subcategorías */}
                <div style={{ marginTop: '12px', paddingLeft: '20px' }}>
                  <h4>Subcategorías:</h4>
                  <ul>
                    {(cat.subcategories || []).map((sub) => (
                      <li key={sub.id}>
                        <input
                          type="text"
                          value={sub.name}
                          onChange={(e) =>
                            setCategorias((prev) =>
                              prev.map((c) =>
                                c.id === cat.id
                                  ? {
                                    ...c,
                                    subcategories: c.subcategories.map((s) =>
                                      s.id === sub.id ? { ...s, name: e.target.value } : s
                                    ),
                                  }
                                  : c
                              )
                            )
                          }
                        />
                        <button onClick={() => editarSubcategoria(sub.id, sub.name)}>💾</button>
                        <button onClick={() => eliminarSubcategoria(sub.id)}>🗑️</button>
                      </li>
                    ))}
                  </ul>

                  {/* Crear nueva subcategoría */}
                  <input
                    type="text"
                    placeholder="Nueva subcategoría"
                    value={
                      nuevaSubcategoria.categoriaId === cat.id ? nuevaSubcategoria.nombre : ''
                    }
                    onChange={(e) =>
                      setNuevaSubcategoria({ nombre: e.target.value, categoriaId: cat.id })
                    }
                  />
                  <button onClick={crearSubcategoria}>➕ Subcategoría</button>
                </div>
              </li>
            ))}
          </ul>
        </div>


      </div>
      < Footer />
    </>
  );
};

export default AdminDash;
